export default [
  {
    key: 'asgard',
    title: 'Asgard',
    shortTitle: 'Asgard',
    description:
      'Asgard, in Norse mythology, is the dwelling place of the gods, similar to Mount Olympus in Greek mythology.',
    credit: 'Scandinavian',
    href: 'https://instagram.com/gecekayaa/',
    textWidth: 1260
  },
  {
    key: 'asgard-god',
    title: 'Asgard',
    shortTitle: 'Asgard',
    description:
      'It is described as being at the highest level of the universe, surrounded by a high wall made of tightly placed stone blocks. At this level, Alfheim, Vanaheim, and Valhalla are located.',
    credit: 'Norway',
    href: 'https://instagram.com/gecekayaa/',
    textWidth: 1260
  },
  {
    key: 'odin',
    title: 'Odin',
    shortTitle: 'Odin',
    description:
      'An important god in Germanic mythology derives his name from Odin, which means "excitation," "fury," and "poetry."',
    credit: 'Norway',
    href: 'https://instagram.com/gecekayaa/',
    textWidth: 1260
  },
  {
    key: 'odin-sleipnir',
    title: 'Odin & Sleipnir',
    shortTitle: 'O&S',
    description:
      'Sleipnir is Odins eight-legged, fast horse in Norse mythology, known as one of his most powerful companions, aiding him in his journeys across realms.',
    credit: 'Scandinavian',
    href: 'https://instagram.com/gecekayaa/',
    textWidth: 1260
  },
  {
    key: 'thor',
    title: 'Thor',
    shortTitle: 'Thor',
    description:
      'The greatest god of Asgard is the Norse deity of thunder, the sky, and agriculture.',
    credit: 'Asgard',
    href: 'https://instagram.com/gecekayaa/',
    textWidth: 1720
  },
  {
    key: 'poseidon',
    title: 'Poseidon',
    shortTitle: 'Poseidon',
    description:
      'Poseidon was the Greek god of the sea and rivers, the creator of storms and floods, and the bringer of earthquakes and destruction.',
    credit: 'Sea',
    href: 'https://instagram.com/gecekayaa/',
    textWidth: 1720
  },
  {
    key: 'zeus-hera',
    title: 'Zeus & Hera',
    shortTitle: 'Zeus & Hera',
    description:
      'They are the king and queen of the gods in Greek mythology: Zeus, god of the sky, and Hera, goddess of marriage, ruling over Mount Olympus.',
    credit: 'Olympus',
    href: 'https://instagram.com/gecekayaa/',
    textWidth: 1720
  },
  {
    key: 'nyks',
    title: 'Nyks',
    shortTitle: 'Nyks',
    description:
      'The goddess of night in Greek mythology, one of the primordial deities, is the embodiment of the night itself.',
    credit: 'He resides in Erebus, another valley of the underworld.',
    href: 'https://instagram.com/gecekayaa/',
    textWidth: 1720
  },
  {
    key: 'aquaman-wonderwoman',
    title: 'Aquaman & Wonderwoman',
    shortTitle: 'A&W',
    description:
      'Aquaman is not a god, but considering his abilities and the amount of power he possesses, he can be regarded as a god. Wonder Woman, on the other hand, is a demigoddess.',
    credit: 'The underwater city of Atlantis & the island of Themyscira.',
    href: 'https://instagram.com/gecekayaa/',
    textWidth: 1720
  },
  {
    key: 'lion-king',
    title: 'Lion King',
    shortTitle: 'Lion King',
    description:
      'The King of the Forest is a title for the dominant animal in the woods, often symbolizing power, like the lion or stag.',
    credit: 'Jungle',
    href: 'https://instagram.com/gecekayaa/',
    textWidth: 1720
  }
];
